<div class="flex-vertical gap-32">
  <oui-button-toggle [options]="investisseurTypeOptions" [control]="investisseurTypeTogglecontrol"></oui-button-toggle>

  <app-search-investisseur-autocomplete
    #investisseurField
    [isRequired]="true"
    [label]="searchInvestisseurLabel"
    [initInvestisseur]="draftOperationsService.investisseur"
    (onInvestisseurPersonneSelected)="onInvestisseurSelected($event)"
    [isInvestisseurSet]="draftOperationsService.getMaxOperationsStateId() >= 5"
    [isContactStatutExcluded]="false"
  [typePersonnes]="[draftOperationsService.investisseurType]"></app-search-investisseur-autocomplete>
  @if (investisseurTypeTogglecontrol.value == 1) {
    @if (draftOperationsService.withCoInvestisseur) {
      <app-search-investisseur-autocomplete
        #coInvestisseurField
        [isRequired]="true"
        [initInvestisseur]="draftOperationsService.coInvestisseur"
        [label]="'Co-investisseur'"
        (onInvestisseurPersonneSelected)="onCoInvestisseurSelected($event)"
        [isInvestisseurSet]="draftOperationsService.getMaxOperationsStateId() >= 5"
      [typePersonnes]="[typeInv.PersonnePhysique]"></app-search-investisseur-autocomplete>
    }
    <div class="flex-vertical gap-16">
      @if (!(draftOperationsService.getMaxOperationsStateId() >= 5)) {
        <oui-slide-toggle
          label="Co-investisseur"
          (checkedChange)="onCoInvestisseurToggled()"
          [checked]="!!draftOperationsService.coInvestisseur"
          >
        </oui-slide-toggle>
      }
      <oui-banner
        type="simple"
        title="Les contreparties pour les dossiers de SCPI en démembrement ne sont pas considérées comme des co-investisseurs, il faut faire une déclaration indépendante."
      [action]="bannerAction"></oui-banner>
    </div>
  }
  @if (investisseurTypeTogglecontrol.value == 2) {
    <div class="flex-vertical gap-8">
      <div class="body-1">La personne morale n’est pas dans la liste ?</div>
      <oui-button class="demandeButton" type="outlined" (click)="onDemandeCreationClick()"
        >Faire une demande de création</oui-button
        >
      </div>
    }
  </div>
